import {useEffect, useState} from "react";
import axios from "axios";

const useAxiosRequest = (request, dependencies = []) => {
    const [ isLoading, setLoading ] = useState(true);
    const [ data, setData ] = useState(null);
    const [ error, setError ] = useState(null);

    useEffect(() => {
        axios(request).then(response => {
            setData(response.data);
            setError(null);
            setLoading(false);
        }).catch(error => {
            setError(error.response);
            setLoading(false);
        });
    }, dependencies);

    return { isLoading, data, setData, error };
}

export default useAxiosRequest;
